module.exports = __webpack_public_path__ + "img/snooker.b09f45b8.svg";